<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="定价表id" prop="productPricingId">
          <el-input v-model="dataForm.productPricingId" placeholder="定价表id"></el-input>
      </el-form-item>
          <el-form-item label="生效日期" prop="effectiveDate">
          <el-input v-model="dataForm.effectiveDate" placeholder="生效日期"></el-input>
      </el-form-item>
          <el-form-item label="产品" prop="product">
          <el-input v-model="dataForm.product" placeholder="产品"></el-input>
      </el-form-item>
          <el-form-item label="城市" prop="city">
          <el-input v-model="dataForm.city" placeholder="城市"></el-input>
      </el-form-item>
          <el-form-item label="是否已生效(1已生效，0未生效)" prop="finalStatus">
          <el-input v-model="dataForm.finalStatus" placeholder="是否已生效(1已生效，0未生效)"></el-input>
      </el-form-item>
          <el-form-item label="状态(1有效，0无效)" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态(1有效，0无效)"></el-input>
      </el-form-item>
          <el-form-item label="产品定价" prop="productPricing">
          <el-input v-model="dataForm.productPricing" placeholder="产品定价"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
          <el-form-item label="默认0未复核,1已复核" prop="reviewersStatus">
          <el-input v-model="dataForm.reviewersStatus" placeholder="默认0未复核,1已复核"></el-input>
      </el-form-item>
          <el-form-item label="复核人" prop="reviewers">
          <el-input v-model="dataForm.reviewers" placeholder="复核人"></el-input>
      </el-form-item>
              <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
          <el-form-item label="删除人" prop="deleteBy">
          <el-input v-model="dataForm.deleteBy" placeholder="删除人"></el-input>
      </el-form-item>
          <el-form-item label="记录产生原因" prop="recordTheCause">
          <el-input v-model="dataForm.recordTheCause" placeholder="记录产生原因"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        productPricingId: '',
        effectiveDate: '',
        product: '',
        city: '',
        finalStatus: '',
        status: '',
        productPricing: '',
        remark: '',
        reviewersStatus: '',
        reviewers: '',
        creator: '',
        createDate: '',
        updateTime: '',
        updateBy: '',
        deleteTime: '',
        deleteBy: '',
        recordTheCause: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        productPricingId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        effectiveDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        product: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        finalStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productPricing: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reviewersStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reviewers: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        recordTheCause: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/productpricinglog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/productpricinglog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
